import { styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(1, 1, 1.5, 1),
  margin: theme.spacing(-1, -1, -1.5, -1),
  '&:before': {
    top: theme.spacing(7)
  }
}));

export const FlexContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  textAlign: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  height: '300px',
  color: theme.color.primary.main,
  border: `1px solid ${theme.color.grey[500]}`
}));

export const Legend = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  marginTop: theme.spacing(1)
}));

export const LegendItem = styled('div')(({ theme, color }) => ({
  display: 'flex',
  fontSize: theme.fontSize.small,
  justifyContent: 'space-around',
  margin: `0 ${theme.spacing(0.5)}`,
  ...(color && {
    '&:before': {
      backgroundColor: color,
      content: '""',
      display: 'inline-block',
      flex: '0 0 auto',
      height: '1em',
      marginRight: theme.spacing(1.25),
      width: '1em'
    }
  })
}));

// Animated container for smooth slide transitions without height cap
export const AnimatedContainer = styled('div')(({ isVisible }) => ({
  display: 'grid',
  gridTemplateRows: isVisible ? '1fr' : '0fr',
  opacity: isVisible ? 1 : 0,
  overflow: 'hidden',
  transition: 'grid-template-rows 0.3s ease-in-out, opacity 0.3s ease-in-out',
  width: '100%',
  '& > *': {
    minHeight: 0,
    overflow: 'hidden'
  }
}));

// Wrapper for expandable content
export const ExpandableSection = styled('div')(() => ({
  width: '100%'
}));
